import { SideTabContentWidthVariant } from './utils';

export const ANIMATION_DURATION = 300;

export const TAB_CARD_ITEM_WIDTH = 193;

export const SIDE_TAB_WIDTH_VARIANTS: Record<SideTabContentWidthVariant, number> = {
    sm: 400,
    md: 600,
    lg: 1200,
    xl: 8000, // just full screen
};
